import { isDefined, get, memoize } from "nodash"
import { createSelector } from "@reduxjs/toolkit"
import { RootState } from "integrations/redux"

const root = (state: RootState) => state.entities.fires

export const selectAllFires = (state: RootState) => root(state).byId

export const selectProjectsByTagFilter = memoize((tagFilterChain: string[]) =>
    createSelector([selectAllFires], (allProjects) => {
        const filteredProjects = Object.values(allProjects).filter((project) => {
            const tagId = get(project, "tagId")
            const filteredTag = tagFilterChain.at(-1)
            if ((tagId === null || tagId === "root") && !filteredTag) return true
            return tagId === filteredTag
        })
        return filteredProjects.filter(isDefined)
    })
)

export const selectFireById =
    (entityId = "") =>
    (state: RootState) =>
        root(state).byId[entityId]

export const selectThumbnailUrlForProject = (projectId: string) => (state: RootState) => {
    return root(state).byId[projectId]?.thumbnailUrl
}

export const selectUpdatingThumbnail =
    (projectId: string) =>
    (state: RootState): boolean => {
        return root(state).backgroundUpdating === projectId
    }

export const selectNeedsSnapshotUpdate = (state: RootState): number =>
    root(state).needsSnapshotUpdate!
